import React from "react";
import { Text, View, Pressable } from "react-native";
import { PolicyStatusColorCode } from "@lib/utilities/Constants";
import { ids, styles } from "./ListItem.styles";
import { theme } from "../../theme/theme";
import { dateFormatter } from "@lib/utilities/Formatters";
import { labelText } from "../../resources/strings";

const ChoosePolicyListItem = (props: any) => {
  // assign prop variables ::
  let policyData = props?.policyData;
  let address = policyData?.physicalAddress;
  let effectiveDate = policyData?.effectiveDate;

  //Get predefined color code of policy status.
  // @ts-ignore
  let policyStatusColorCode = PolicyStatusColorCode[`${policyData.policyStatus}`];
  if (
    policyStatusColorCode === null ||
    typeof policyStatusColorCode === "undefined"
  ) {
    policyStatusColorCode = theme.colors.policyStatus.tertiary;
  }

  return (
      <View
        style={[styles.choosePolicyCtr]}
        dataSet={{ media: ids.choosePolicyCtr }}
      >
        <Pressable
          onPress={() => props.onItemPress(policyData)}
          style={[styles.choosePolicyTabActive, styles.marginBottom]}
          dataSet={{ media: ids.choosePolicyTabActive }}
          testID={`policy-list-item-${policyData.policyNumber}`}
        >
          <View
            style={[styles.productDetailsView]}
            dataSet={{ media: ids.productDetailsView }}
          >
            <Text
              style={[styles.productDetailsText]}
              dataSet={{ media: ids.productDetailsText }}
            >
              {policyData.product}
            </Text>
          </View>
          <Text style={[styles.policyText]} dataSet={{ media: ids.policyText }}>
            {policyData.policyNumber}
          </Text>
          <Text
            style={[styles.policyAddressText, styles.marginTop]}
            dataSet={{ media: ids.policyAddressText }}
          >
            {address?.address1}
          </Text>
          <Text
            style={[styles.policyAddressText]}
            dataSet={{ media: ids.policyAddressText }}
          >
            {address?.city}, {address?.state}
          </Text>
          <View style={styles.effectiveDateView}>
            <Text
              style={[styles.effectiveDateTextMuted]}
              dataSet={{ media: ids.policyAddressText }}
            >
              {labelText.policies.effectiveDate}
            </Text>
            <Text
              style={[styles.effectiveDateText]}
              dataSet={{ media: ids.policyAddressText }}
            >
              {" "}{dateFormatter(effectiveDate)}
            </Text>
          </View>
          {policyData.status !== "" && (
            <Text
              style={[
                styles.policyStatusText,
                { backgroundColor: policyStatusColorCode },
              ]}
              dataSet={{ media: ids.policyStatusText }}
            >
              {policyData?.policyStatus}
            </Text>
          )}
        </Pressable>
      </View>
  );
};

export default ChoosePolicyListItem;
